import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx';

const CaptainDetailNotes = ({
  notes,
  onEditClick
}) => (
  <Panel className="panel-primary"
    style={{minHeight: 200}}
    title={
      <span>{'Notes'}
        <button className="btn btn-link pull-right"
          onClick={onEditClick}>
          <i className="fa fa-pencil"/> {'Edit'}
        </button>
      </span>
    }>
    <div style={{
      overflowY: 'auto',
      height: 102
    }}>{notes || 'Click \'Edit\' to add notes here...'}</div>
  </Panel>
);

CaptainDetailNotes.propTypes = {
  notes: PropTypes.string,
  onEditClick: PropTypes.func
};

CaptainDetailNotes.defaultProps = {
  notes: ''
};

export default CaptainDetailNotes;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainDetailNotes.jsx